import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { ApiServiceProvider } from '../api-service/api-service';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { Observable } from 'rxjs';
import { AppSettings } from '../../app/app.settings';
import { JwtHelper } from 'angular2-jwt';
import { Events } from 'ionic-angular';
import { UtilsServiceProvider } from '../../providers/utils-service/utils-service';

@Injectable()
export class ProfileServiceProvider {
  private jwtHelper: any = new JwtHelper();
  private user: any = null;

  constructor(
    public apiService: ApiServiceProvider,
    public events: Events,
    public storageService: StorageServiceProvider,
    public utilsService: UtilsServiceProvider
  ) {}

  public loginAccount() {
    let url = AppSettings.API_ENDPOINT + '/auth/facebook';
    (location.href = url), '_system', 'location=yes';
  }

  public instagramLogin(acessToken) {
    return this.apiService
      .get('/auth/mobile/instagram/' + acessToken)
      .toPromise();
  }

  public setToken(token, refreshToken = null) {
    this.apiService.setToken(token);
    this.storageService.setStorage('JWTToken', token);
    if (refreshToken) {
      this.storageService.setStorage('refreshToken', refreshToken);
    }
  }

  public logout() {
    this.apiService.unsetToken();
    this.storageService.removeStorage('JWTToken');
    this.user = null;
    this.events.publish('logout');
  }

  public getUserById(id) {
    return this.apiService.get('/users/' + id);
  }

  public getUsers(filter) {
    return this.apiService.get('/users' + '?query=' + filter);
  }

  public removeAccount(userId) {
    return this.apiService.delete('/users/' + userId);
  }

  public getUser(redirect = false) {
    if (!this.user || !this.user.id) {
      let jwt = this.storageService.getStorage('JWTToken');
      if (jwt) {
        let refreshToken = this.storageService.getStorage('refreshToken');
        this.loadUser(jwt, refreshToken);
      } else {
        if (redirect) {
          return null;
        } else {
          this.logout();
        }
      }
    }
    return this.user;
  }

  public loadUser(jwt, refreshToken) {
    this.setToken(jwt, refreshToken);
    this.user = this.jwtHelper.decodeToken(jwt);
  }

  public authMobile(accessToken, userId) {
    return this.apiService.post('/auth/mobile', { accessToken, userId });
  }

  public addBio(id: string, bio: string) {
    return this.apiService.put(`/users/${id}/bio`, { bio });
  }

  public getRequestsThankedByUserId(id, page = 1, limit = 100) {
    return this.apiService.get(
      `/users/${id}/thanks?page=${page}&limit=${limit}`
    );
  }

  public updatePhotoProfile(id, picture) {
    return this.apiService.put(`/users/${id}/picture/`, { picture });
  }

  public addDeviceToken(token, userId) {
    return this.apiService.put(`/users/${userId}/device-token/${token}`, {});
  }

  public removeDeviceToken(userId) {
    return this.apiService.delete(`/users/${userId}/device-token`);
  }
}



// WEBPACK FOOTER //
// ./src/providers/profile-service/profile-service.ts